import * as dateUtility from "./utilities/date.js";
import * as directUploadUtility from "./utilities/direct-upload.js";
import * as imageUtility from "./utilities/image.js";

window.App || (window.App = {});
window.App.dateUtility = dateUtility;
window.App.directUploadUtility = directUploadUtility;
window.App.imageUtility = imageUtility;
